import { CarouselItemViewModel, ComponentType } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
interface Props extends CarouselItemViewModel, IsLoadingLazyProps, DataLayerProps {}
export default function CarouselIconItem({
  link,
  desktopImageUrl,
  mobileImageUrl,
  title,
  isLazy,
  index,
  id,
  componentId,
  sortKey
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const handleClick = () => {
    sendCtaClickEvent({
      elementType: ComponentType.CarouselIcon,
      elementIndex: index || 0,
      itemID: id ?? '',
      elementName: sortKey,
      destinationUrl: link ?? '',
      componentId: componentId ?? '',
      ImageUrl: isMobile ? mobileImageUrl : desktopImageUrl
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.CarouselIcon,
      banner_name: sortKey ?? '',
      banner_index: index?.toString() || '0',
      url_destination: link || '',
      item_id: id || '',
      component_id: componentId ?? '',
      image_url: (isMobile ? mobileImageUrl : desktopImageUrl) ?? ''
    });
  };
  const imageSize = isMobile ? 48 : 64;
  return <AppNextLink href={link || ''} onClick={handleClick} prefetch={false} className='keen-slider__slide block overflow-hidden rounded text-center' data-sentry-element="AppNextLink" data-sentry-component="CarouselIconItem" data-sentry-source-file="carousel-icon-item.tsx">
            <picture data-sentry-element="picture" data-sentry-source-file="carousel-icon-item.tsx">
                <source media='(min-width: 1024px)' srcSet={desktopImageUrl || ''} />

                <LazyImage src={mobileImageUrl || ''} alt={title || link || 'ایتم اسلایدر ایکون'} className='mx-auto block w-16 overflow-hidden rounded-full md:w-20' loaderClassName='aspect-square' isLazy={isLazy} width={imageSize} height={imageSize} data-sentry-element="LazyImage" data-sentry-source-file="carousel-icon-item.tsx" />
            </picture>
            <div className='mt-1.5 text-caption-12 font-medium lg:mt-3 lg:text-body-14'>{title}</div>
        </AppNextLink>;
}